// Compara el valor del Select de razón (string libre de attention_voucher_reason)
// contra el catálogo voucher_reason (con es_emergencia), tolerante a diferencias
// de mayúsculas/espacios — las dos tablas no están normalizadas entre sí.
export function isEmergencyReason(selectedReason, voucherReasons) {
  if (!selectedReason || !Array.isArray(voucherReasons)) return false;
  const norm = (s) =>
    String(s ?? '')
      .trim()
      .toLowerCase();
  const target = norm(selectedReason);
  const found = voucherReasons.find((r) => norm(r.nombre) === target);
  return Boolean(found && (found.es_emergencia === true || found.es_emergencia === 1));
}
